import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { TooltipLoader } from '../../global/TooltipLoader';
import styles from './PdpSharedDealerDistinctions.scss';
import classnames from 'classnames';

export class PdpSharedDealerDistinction extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isHovered: false,
            load: false,
        };
    }

    render() {
        const { title, description, icon: Icon, dataTn } = this.props;
        const iconClassName = classnames(this.props.customIconStyles, styles.icon);
        const { isHovered, load } = this.state;
        const mouseProps = description && {
            onMouseEnter: () => this.setState({ isHovered: !isHovered, load: true }),
            onMouseLeave: () => this.setState({ isHovered: !isHovered }),
        };

        return (
            <div {...mouseProps} className={styles.distinction} data-tn={dataTn}>
                <Icon className={iconClassName} />
                <span className={styles.title}>{title}</span>

                {description && (
                    <TooltipLoader
                        load={load}
                        isVisible={isHovered}
                        align="right"
                        direction="bottom"
                        paddingSize="small"
                    >
                        {description}
                    </TooltipLoader>
                )}
            </div>
        );
    }
}

PdpSharedDealerDistinction.propTypes = {
    title: PropTypes.node.isRequired,
    description: PropTypes.node,
    icon: PropTypes.func.isRequired,
    dataTn: PropTypes.string,
    customIconStyles: PropTypes.string,
};
